class MobileSearch extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="text"]');
    this.toggleButton = this.querySelector("button");
    this.block = false;
    this.form = this.querySelector("form");
    this.results = this.querySelector("[data-results]");
    this.suggestions = this.querySelectorAll("[data-suggestions] a");
    this.debounceTimeout = null;
    this.debug = false;
    this.setOverlayHeight();

    this.form.addEventListener("keydown", (e) => {
      if (e.key === "Enter" && this.searchValue !== "") {
        window.location.href = `/search?q=${this.searchValue}&type=product`;
      }
    });
  }

  setOverlayHeight() {
    const headerHeight =
      document.getElementById("shopify-section-wf-announcement-bar")
        .offsetHeight +
      document.getElementById("shopify-section-header").offsetHeight;
    this.querySelector(
      ".search-bar-overlay"
    ).style.height = `calc(100vh - ${headerHeight}px)`;
  }

  connectedCallback() {
    this.input.addEventListener("input", this.handleChange.bind(this));
    this.toggleButton.addEventListener("click", this.handleToggle.bind(this));
    this.input.addEventListener("focus", this.handleFocus.bind(this));
  }

  disconnectedCallback() {
    this.input.removeEventListener("input", this.handleChange.bind(this));
    this.toggleButton.removeEventListener(
      "click",
      this.handleToggle.bind(this)
    );
    this.input.removeEventListener("focus", this.handleFocus.bind(this));
  }

  handleFocus(e) {
    this.input.classList.add("active");
  }

  handleToggle(e) {
    e.preventDefault();
    this.isOpen = this.input.classList.contains("active");
    if (this.isOpen) {
      this.input.classList.remove("active");
      this.input.value = "";
      this.setInitialState();
    }
  }

  filterSuggestionValues(searchTerm) {
    let sectionShow = false;
    this.suggestions.forEach((linkNode) => {
      if (
        linkNode
          .getAttribute("data-linkname")
          .toLowerCase()
          .includes(searchTerm.toLowerCase()) &&
        searchTerm.toLowerCase() != ""
      ) {
        linkNode.classList.remove("hidden");
        sectionShow = true;
      } else {
        linkNode.classList.add("hidden");
      }
      if (searchTerm.toLowerCase() == "") this.setInitialState();
    });

    sectionShow
      ? document.querySelector(".wf-suggestions").classList.remove("hidden")
      : document.querySelector(".wf-suggestions").classList.add("hidden");
  }

  handleChange(e) {
    if (this.debug) {
      console.log("Change Detected", this.searchValue);
    }
    this.searchValue = this.input.value;
    this.filterSuggestionValues(this.input.value);

    if (this.searchValue === "") {
      this.setInitialState();
      return;
    }

    if (this.debounceTimeout) {
      clearTimeout(this.debounceTimeout);
    }

    this.debounceTimeout = setTimeout(() => {
      this.search();
    }, 500);
  }

  async search() {
    if (this.debug) {
      console.log("MAKING API REQUEST", this.searchValue);
    }
    this.results.innerHTML = `<div class="main-search__results-spinner wf"><div class="wf-spinner"></div></div>`;
    this.setSearchState();
    let actionURL = "/search?sections=mini-search-results";
    let delimiter = actionURL.indexOf("?") > -1 ? "&" : "?";
    let formData = new URLSearchParams(new FormData(this.form)).toString();
    let fetchUrl = `${actionURL}${delimiter}${formData}`;

    let content = await fetch(fetchUrl);
    let contentJSON = await content.json();

    let contentHTML = contentJSON["mini-search-results"];

    console.log(`/search?q=${this.searchValue}&type=product`);
    this.results.innerHTML = contentHTML;
    // console.log(contentHTML);
    // console.log("Request Done", this.searchValue);
  }

  setInitialState(e) {
    if (this.debug) {
      console.log("Setting Initial State");
    }
    this.querySelector(".initial-state").style.display = "block";
    this.querySelector(".results-container").style.display = "none";
    document.querySelector(".wf-suggestions").classList.add("hidden");
  }

  setSearchState() {
    if (this.debug) {
      console.log("Setting Search State");
    }
    this.querySelector(".initial-state").style.display = "none";
    this.querySelector(".results-container").style.display = "block";
  }
}

class DesktopSearch extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="text"]');
    this.toggleButton = this.querySelector("button");
    this.block = false;
    this.form = this.querySelector("form");
    this.modal = this.querySelector(".search-bar-overlay");
    this.results = this.querySelector("[data-results]");
    this.suggestions = this.querySelectorAll("[data-suggestions] a");
    this.debounceTimeout = null;
    this.debug = false;
    // this.setOverlayHeight();
    window.addEventListener("click", (event) => this.handleOutsideClick(event));
    this.form.addEventListener("keydown", (e) => {
      if (e.key === "Enter" && this.searchValue !== "") {
        window.location.href = `/search?q=${this.searchValue}&type=product`;
      }
    });
  }

  handleOutsideClick(e) {
    if (
      !e.target.closest(".search-bar-overlay") &&
      !e.target.closest(".desktop-search-form") &&
      this.input.classList.contains("active")
    ) {
      this.handleToggle(e);
    }
  }

  setOverlayHeight() {
    const headerHeight =
      document.querySelector("body").offsetHeight -
      document.querySelector(".main-content").offsetHeight -
      document.querySelector(".shopify-section-footer").offsetHeight +
      document.querySelector(".wf-searchbar").offsetHeight;
    document.querySelector(
      ".search-bar-overlay"
    ).style.height = `calc(100vh - ${headerHeight}px)`;
  }

  connectedCallback() {
    this.input.addEventListener("input", this.handleChange.bind(this));
    this.toggleButton.addEventListener("click", this.handleToggle.bind(this));
    this.input.addEventListener("focus", this.handleFocus.bind(this));
  }

  disconnectedCallback() {
    this.input.removeEventListener("input", this.handleChange.bind(this));
    this.toggleButton.removeEventListener(
      "click",
      this.handleToggle.bind(this)
    );
    this.input.removeEventListener("focus", this.handleFocus.bind(this));
  }

  handleFocus(e) {
    this.input.classList.add("active");
  }

  handleToggle(e) {
    e.preventDefault();
    this.isOpen = this.input.classList.contains("active");
    if (this.isOpen) {
      this.input.classList.remove("active");
      this.input.value = "";
      this.setInitialState();
    }
  }

  filterSuggestionValues(searchTerm) {
    let sectionShow = false;
    this.suggestions.forEach((linkNode) => {
      if (
        linkNode
          .getAttribute("data-linkname")
          .toLowerCase()
          .includes(searchTerm.toLowerCase()) &&
        searchTerm.toLowerCase() != ""
      ) {
        linkNode.classList.remove("hidden");
        sectionShow = true;
      } else {
        linkNode.classList.add("hidden");
      }
      if (searchTerm.toLowerCase() == "") this.setInitialState();
    });

    sectionShow
      ? document.querySelector(".wf-suggestions").classList.remove("hidden")
      : document.querySelector(".wf-suggestions").classList.add("hidden");
  }

  handleChange(e) {
    if (this.debug) {
      console.log("Change Detected", this.searchValue);
    }
    this.searchValue = this.input.value;
    this.filterSuggestionValues(this.input.value);

    if (this.searchValue === "") {
      this.setInitialState();
      return;
    }

    if (this.debounceTimeout) {
      clearTimeout(this.debounceTimeout);
    }

    this.debounceTimeout = setTimeout(() => {
      this.search();
    }, 500);
  }

  async search() {
    if (this.debug) {
      console.log("MAKING API REQUEST", this.searchValue);
    }
    this.results.innerHTML = `<div class="wf-spinner"></div>`;

    this.setSearchState();
    let actionURL = "/search?sections=mini-search-results";
    let delimiter = actionURL.indexOf("?") > -1 ? "&" : "?";
    let formData = new URLSearchParams(new FormData(this.form)).toString();
    let fetchUrl = `${actionURL}${delimiter}${formData}`;

    let content = await fetch(fetchUrl);
    let contentJSON = await content.json();

    let contentHTML = contentJSON["mini-search-results"];

    this.results.innerHTML = contentHTML;
    // console.log(contentHTML);
    // console.log("Request Done", this.searchValue);
  }

  setInitialState(e) {
    if (this.debug) {
      console.log("Setting Initial State");
    }
    this.querySelector(".initial-state").style.display = "block";
    this.querySelector(".results-container").style.display = "none";
    document.querySelector(".wf-suggestions").classList.add("hidden");
  }

  setSearchState() {
    if (this.debug) {
      console.log("Setting Search State");
    }
    this.querySelector(".initial-state").style.display = "none";
    this.querySelector(".results-container").style.display = "block";
  }
}

window.customElements.define("mobile-search", MobileSearch);
window.customElements.define("desktop-search", DesktopSearch);

// Collection description
document.addEventListener("DOMContentLoaded", function () {
  const description = document.querySelector(".wf-category-description");
  const readMoreBtn = document.querySelector(".wf-read-more-btn");
  if (!description || !readMoreBtn) return;
  const descriptionHeight = description.scrollHeight;

  if (descriptionHeight > 120) {
    description.classList.add("show--toggle");
    readMoreBtn.style.display = "block";
  }

  readMoreBtn.addEventListener("click", function () {
    description.classList.toggle("expanded");
    description.style.maxHeight = description.classList.contains("expanded")
      ? `${descriptionHeight}px`
      : "120px";
    readMoreBtn.textContent = description.classList.contains("expanded")
      ? "Weniger lesen"
      : "Weiterlesen";
  });
});
